import { BUSCAR_VENDA_URBANA, LIMPAR_VENDA_URBANA } from '../../actions/types'

const initial = null

export default function reducerVendaUrbana (state = initial, action = {}) {
  switch (action.type) {
    case BUSCAR_VENDA_URBANA: {
      return action.payload
    }

    case LIMPAR_VENDA_URBANA: {
      return initial
    }

    default:
      return state
  }
}
